import { Data, Effect } from "effect"

interface Blobbable {
    toBlob(callback: BlobCallback, type?: string, quality?: number): void
}

/**
 * Gets a blob out of a canvas or something similar
 */
export const Blobbify = Effect.fn("Blobbify")((
    blobbable: Blobbable,
    type?: string,
    quality?: number,
) => {
    return Effect.async<Blob, BlobbificationError>((res) => {
        blobbable.toBlob(
            (blob) => {
                if (!blob)
                    return res(
                        Effect.fail(
                            new BlobbificationError({ message: "Blob failed! Blob is null" }),
                        ),
                    )
                return res(Effect.succeed(blob))
            },
            type,
            quality,
        )
    })
})

export class BlobbificationError extends Data.TaggedError("BlobbificationError")<{
    message: string
}> {}
